import { render, staticRenderFns } from "./SubscriptionDialog.vue?vue&type=template&id=471a7d99&"
import script from "./SubscriptionDialog.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports